
    <div class="ui-g-12">
      <!-- Upload Immagine -->
      <div class="ui-g-12 ui-md-4 ui-g-nopad sf-field-container">
        <div class="ui-g-12 ui-md-9">
          <span class="label">
            {{ schema.description }}
          </span>
        </div>
        <div class="ui-g-12 ui-md-3">
          <label id="upload-img-label">
            <input
              type="file"
              (change)="uploadImg($event.target.files)"
              accept=".png, .jpg, .jpeg, .pdf"/>
              {{ 'common.upload' | translate }}
          </label>
        </div>
      </div>
      <div class="ui-g-12 ui-md-1"></div>
      <!-- Anteprima Immagine -->
      <div class="ui-g-12 ui-md-4 ui-g-nopad" style="padding-left: 50px;">
        <div id="img-container" [hidden]="!control.value">
          <img [src]="control.value" width="100" alt="anteprima immagine">
          <button
            pButton
            type="button"
            (click)="removeImage()"
            icon="fa fa-times"
            id="remove-img-btn"
            class="ui-button-danger btnDelete">
          </button>
        </div>
      </div>
      <div class="ui-g-12 ui-md-3"></div>
    </div>
  


// WEBPACK FOOTER //
// ./src/app/views/administration/apps-config/json-schema-form/custom-widgets/image-upload.widget.ts.ImageUploadWidget.html